<div>
  <div class="status-box tw-items-center">
    <span class="status-indicator {{ data.status.borrower_stage_lookup.stage }}"></span>
    <span class="tw-mr-4 tw-text-gray-400">{{ data.status.label }}</span>
  </div>
  <div class="tw-mt-4">
    Change To
  </div>

  <div class="tw-my-4">
    <div class="status-box tw-w-52 tw-items-center">
      <span class="status-indicator {{ selectedOption ? selectedOption?.borrower_stage_lookup?.stage : 'null' }}"></span>
      <mat-select
        (selectionChange)="handleSelectionChange($event)"
        [(value)]="selectedOption"
        placeholder="Select New Status">
        <mat-select-trigger class="tw-flex tw-items-center">
          <span class="tw-mr-3 tw-text-gray-400">{{ selectedOption?.label }}</span>
        </mat-select-trigger>
        <mat-option
          *ngFor="let option of (statusOptions$ | async)"
          [value]="option">
          {{option.label}}
        </mat-option>
      </mat-select>
    </div>
  </div>

  <ng-container *ngIf="selectedOption && selectedOption.status !== 'doNotContact'">
    <div>
      <p class="tw-pt-3">Why are you moving this borrower to "{{ selectedOption.label }}"?</p>

      <form [formGroup]="form" id="borrower-status-reason-form">
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      </form>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedOption?.status === 'doNotContact'">

    <div>

      <formly-form [form]="dncForm" [fields]="dncFields" [model]="dncModel"></formly-form>

      <p>Are you sure you want to move this borrower to "{{ selectedOption.label }}"?</p>
      <p>This business will be placed on a "Do Not Contact" list and this can be undone by a manager only.</p>
    </div>

  </ng-container>

  <mat-dialog-actions class="tw-mt-2">
    <button
      mat-raised-button
      [color]="'primary'"
      [disabled]="!selectedOption || (selectedOption.status === 'doNotContact' && !dncForm.valid) || (selectedOption.status !== 'doNotContact' && !form.valid)"
      (click)="confirmChangeStatus()"
    >
      Confirm
    </button>
  </mat-dialog-actions>

</div>
